import { useEffect, useState } from 'react';
import { ApplicationType } from '@myme/utils';
import { useWindowDimensions } from './useWindowDimensions';

export const useDetectDevice = () => {
  const [device, setDevice] = useState<ApplicationType | null>(null);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const { deviceWidth } = useWindowDimensions();
  const desktopWebApp = deviceWidth > 768;

  const isDesktop = device === 'WEB';
  const isMobileFromWeb = device === 'MOBILE_WEB';

  useEffect(() => {
    if (isMobile) {
      setDevice('MOBILE');
    }
    if (!isMobile) {
      setDevice(desktopWebApp ? 'WEB' : 'MOBILE_WEB');
    }
  }, [desktopWebApp]);

  return { device, isDesktop, isMobile, isMobileFromWeb };
};
